// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2QmsJ","footer":"ChangeClinic_footer__yoo5u"};